<div class="sticky top-16 z-[30] bg-white pb-2">
  <nav compact tuiSubheader class="bg-white">
    <tui-breadcrumbs [itemsLimit]="10">
      <ng-container *ngFor="let item of breadcrumbs; let last = last">
        <ng-container *ngIf="last">
          <strong *tuiItem tuiFade>
            {{ item }}
          </strong>
        </ng-container>
        <ng-container *ngIf="!last">
          <button *tuiItem tuiLink type="button">
            {{ item }}
          </button>
        </ng-container>
      </ng-container>
    </tui-breadcrumbs>
  </nav>

  <div class="items-center flex justify-between">
    <p class="text-[1.25rem] font-bold mt-[0.9rem] text-[#000000A6]">Users</p>

    <button [routerLink]="['/admin/users/add-edit']" tuiButton type="button" size="s">
      Add New User
    </button>

  </div>


  <!-- 1. Search Inputs Row -->
  <div class="flex items-center space-x-4 mb-4">
    <div class="w-[431px]">
      <tui-textfield iconStart="@tui.search" tuiTextfieldSize="m">
        <input [(ngModel)]="filters.searchText" placeholder="Search Users" (keydown)="onEnter($event)" tuiTextfield />
      </tui-textfield>
    </div>

    <div class="w-[180px]">
      <tui-combo-box tuiTextfieldSize="m" [stringify]="stringify" [(ngModel)]="filters.status"
        (ngModelChange)="applyFilters({ status: filters.status })">
        Status
        <input tuiTextfieldLegacy placeholder="Select status" [value]="stringify(filters.status)" />
        <tui-data-list-wrapper *tuiDataList [items]="items" [itemContent]="stringify | tuiStringifyContent" />
      </tui-combo-box>
    </div>

    <button (click)="loadUsers()" appearance="secondary" size="m" tuiButton type="button" class="w-full sm:w-auto"
      style="border: 2px solid #e5e7ea; font-weight: 800">
      Search
    </button>
  </div>
</div>

<!-- 2. Results Info & Archive Toggle Row (Pushed to edges) -->
<div class="flex items-center justify-between w-full mb-2">
  <!-- Left side -->
  <div class="flex items-center space-x-4">
    <p class="text-sm font-semibold text-[#26293C] my-0">
      Showing results for "{{ filters.searchText || "All Users" }}"
    </p>
    <button appearance="flat" iconStart="@tui.rotate-cw" size="xs" tuiButton type="reset" (click)="clearSearch()">
      Clear
    </button>
  </div>

  <!-- Right side (This will now go to the far right of the screen) -->
  <div class="flex items-center space-x-2">
    <p class="text-sm font-medium text-[#191C30E5] my-0">Show Archived</p>
    <input title="Archived switch" tuiSwitch type="checkbox" [(ngModel)]="filters.archived"
      (change)="applyFilters({ archived: filters.archived })" />
  </div>
</div>

<div *ngIf="isLoading" class="h-[400px]">
  <tui-loader />
</div>

<!-- Bulk-action bar: visible when at least one row is selected -->
<div *ngIf="!isLoading && selectionCount() > 0"
  class="flex items-center justify-between mt-4 p-3 rounded-md bg-[#F9FBFF] border border-[#E5E7EA]">
  <p class="text-sm font-medium text-[#191C30E5] m-0">
    {{ selectionCount() }} selected
  </p>
  <div class="flex items-center space-x-2">
    <button size="xs" appearance="secondary" tuiButton type="button" [disabled]="bulkBusy"
      [appDisableUnlessPermission]="'USER_UPDATE'" (click)="bulkArchiveSelected(true)">
      Archive selected
    </button>
    <button size="xs" appearance="secondary" tuiButton type="button" [disabled]="bulkBusy"
      [appDisableUnlessPermission]="'USER_UPDATE'" (click)="bulkArchiveSelected(false)">
      Unarchive selected
    </button>
    <button size="xs" appearance="secondary" tuiButton type="button" (click)="exportSelectedToCsv()">
      Export CSV
    </button>
  </div>
</div>

<div *ngIf="!isLoading" class="w-full mt-5 md:overflow-x-scroll lg:overflow-x-scroll xl:overflow-x-scroll">
  <table tuiTable [size]="size" class="w-[100rem] md:w-[100rem] lg:w-[90rem] xl:w-[90rem] 2xl:w-[120rem]">
    <thead>
      <tr>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
            width: 40px;
          ">
          <input type="checkbox" title="Select all on this page" [checked]="isAllSelected()"
            (change)="toggleSelectAll($any($event.target).checked)" />
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          User ID
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          User Name
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          Email Address
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          Phone Number
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          Role
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 20px;
            background-color: #f9fbff;
          ">
          Status
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          Created Date
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          Actions
        </th>
      </tr>
    </thead>

    <tbody tuiTbody>
      <tr *ngFor="let user of userData">
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <input type="checkbox" [title]="'Select ' + (user?.name || 'user')" [checked]="isSelected(user?._id)"
            (change)="toggleSelected(user?._id, $any($event.target).checked)" />
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p [routerLink]="['/admin/user/', user?._id]" class="text-[#526ED3] text-sm cursor-pointer">
              {{ user?.refNo }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">{{ user?.name }}</p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">{{ user?.email }}</p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">{{ user?.contactNo }}</p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">{{ user?.role?.name || '-' }}</p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <p class="text-center w-[75px] py-0.5 px-2 rounded-full text-white"
            [style.background-color]="user?.active ? '#6BC68A' : 'red'">
            {{ user?.active ? "Active" : "Inactive" }}
          </p>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">
              {{ user?.createdAt | date : "MMM d, y" }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <span tuiStatus>
            <p [routerLink]="['/admin/user/', user?._id]"
              class="text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer">
              View
            </p>
            <button [routerLink]="['/admin/users/add-edit', user?._id]" [disabled]="user?.archived" [style.color]="
                user?.archived
                  ? '#a6afce'
                  : loggedInUserCanEdit
                  ? '#526ED3'
                  : '#a6afce'
              "
              class="appearance-none bg-white border-none pt-[3px] m-0 underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer">
              Edit
            </button>
            <div>
              <button appearance="action" iconStart="@tui.ellipsis" size="xs" tuiIconButton type="button"
                [tuiAppearanceState]="openMap[user?._id] ? 'hover' : null" [tuiDropdown]="content"
                [disabled]="!loggedInUserCanEdit" [style.color]="!loggedInUserCanEdit ? '#a6afce' : '#526ED3'"
                [(tuiDropdownOpen)]="openMap[user?._id]" (click)="toggleDropdown(user?._id)">
                More
              </button>
              <ng-template #content>
                <tui-data-list tuiDataListDropdownManager [size]="openDropdownsize">
                  <button style="color: black" tuiOption class="dropdown-button" type="button"
                    (click)="resetUserPassword(user?.email)">
                    Reset Password
                  </button>
                  <button style="color: black" tuiOption class="dropdown-button" type="button"
                    (click)="toggleActive(user?._id)">
                    {{ user?.active ? "Deactivate" : "Activate" }}
                  </button>
                  <button style="color: black" tuiOption class="dropdown-button" type="button"
                    (click)="toggleArchive(user?._id)">
                    {{ user?.archived ? "Unarchive" : "Archive" }}
                  </button>
                </tui-data-list>
              </ng-template>
            </div>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Pagination Controls -->
<div class="flex justify-end items-center mt-5">
  <tui-pagination [index]="pageIndex - 1" [length]="getPageCount()" (indexChange)="onPageChange($event + 1)">
  </tui-pagination>
</div>